import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    taskDists: [],
    count: 0,
    page: 1,
    pageSize: 25,
    pages: 0,
    sortField: 'updated_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    crowdWorkers: [],
    cwCount: 0,
    cwPage: 1,
    cwPageSize: 25,
    cwPages: 0,
    cwSortField: 'email',
    cwSortOrder: 'asc',
    cwSearch: null,
    cwError: '',
    crowdGroupId: null,
    openAssignNewCrowdWorkerForm: false,
    searchKeyword: '',
    searchWorker: null,
    asignCrowdWorkerError: null,
    anyChanges: false
}

const receivedCrowdWorkersData=(state,action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;

    return {
        ...state,
        crowdWorkers: results,
        cwCount: count,
        cwPage: page,
        cwPageSize: pageSize,
        cwPages: pages,
        cwSortField: sortField,
        cwSortOrder: sortOrder,
        cwSearch: search,
        anyChanges: false,
        crowdGroupId: action.crowdGroupId,
        openAssignNewCrowdWorkerForm: false,
    }
}

const openAssignNewCrowdWorkerForm=(state)=>{
    return {
        ...state,
        openAssignNewCrowdWorkerForm: true,
        searchWorker: null,
        asignCrowdWorkerError: null
    }
}

const cancelAssignNewCrowdWorkerForm=(state)=>{
    return {
        ...state,
        openAssignNewCrowdWorkerForm: false
    }
}

const receivedCrowdWorkersError=(state, action)=> {
    return {
        ...state,
        cwError: action.error
    }
}

const setSearchKeyword=(state,action)=>{
    return {
        ...state,
        searchKeyword: action.searchKeyword
    }
}

const receivedSearchCrowdWorker=(state, action )=>{
    return {
        ...state,
        searchWorker: action.worker,
        asignCrowdWorkerError: null
    }
}

const receivedSearchCrowdWorkerError=(state,action)=>{
    return {
        ...state,
        asignCrowdWorkerError: action.error
    }
}

const assignNewCrowdWorkerSuccess=(state)=>{
    return {
        ...state,
        asignCrowdWorkerError: null,
        anyChanges: true,
        openAssignNewCrowdWorkerForm: false
    }
}

const assignNewCrowdWorkerError=(state,action)=>{
    return {
        ...state,
        asignCrowdWorkerError: action.error,
    }
}

const deletedACrowdWorkerSuccess=(state)=>{
    return {
        ...state,
        anyChanges: true,
        cwError: null
    }
}

const deletedACrowdWorkerError=(state,action)=>{
    return {
        ...state,
        cwError: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.GET_CROWD_WORKERS_DATA]: receivedCrowdWorkersData,
    [actionTypes.GET_CROWD_WORKERS_DATA_ERROR]: receivedCrowdWorkersError,
    [actionTypes.OPEN_ASSIGN_NEW_CROWD_WORKER_FORM]: openAssignNewCrowdWorkerForm,
    [actionTypes.CANCEL_ASSIGN_NEW_CROWD_WORKER_FORM]: cancelAssignNewCrowdWorkerForm,
    [actionTypes.SET_SEARCH_KEYWORD]: setSearchKeyword,
    [actionTypes.RECEIVED_SEARCH_CROWD_WORKER]: receivedSearchCrowdWorker,
    [actionTypes.RECEIVED_SEARCH_CROWD_WORKER_ERROR]: receivedSearchCrowdWorkerError,
    [actionTypes.ASSIGN_NEW_CROWD_WORKER_SUCCESS]: assignNewCrowdWorkerSuccess,
    [actionTypes.ASSIGN_NEW_CROWD_WORKER_ERROR]: assignNewCrowdWorkerError,
    [actionTypes.DELETED_A_CROWD_WORKER_SUCCESS]: deletedACrowdWorkerSuccess,
    [actionTypes.DELETED_A_CROWD_WORKER_ERROR]: deletedACrowdWorkerError
});


// WEBPACK FOOTER //
// ./src/redux/crowdWorkers/reducer.js